module.exports = __webpack_public_path__ + "img/cloud-hail-lightning-sun-2.7cc51421.svg";